import { createSelector } from "reselect";

import products from "state/selectors/products";

import {
  GlobalState,
  Products,
  Variant,
  LineItems,
  CartLineItems,
  CartLineItem,
  Product
} from "types";

export default createSelector(
  (state: GlobalState): Products | null => products(state),
  (state: GlobalState): LineItems => state.session.checkout.checkout.lineItems,
  (products: Products | null, lineItems: LineItems): CartLineItems => {
    if (!products) {
      return [];
    }

    return lineItems.map(
      (lineItem): CartLineItem => {
        const defaultCartLineItem = {
          prefix: "",
          title: "",
          price: {
            amount: 0
          },
          variantOptions: [],
          productOptions: [],
          quantity: 0,
          image: {
            url: "",
            title: "",
            description: ""
          },
          productHandle: "",
          variantId: ""
        };
        const lineItemProduct: Product | undefined =
          products[lineItem.productHandle];

        if (!lineItemProduct) {
          return defaultCartLineItem;
        }

        const lineItemVariant:
          | Variant
          | undefined = lineItemProduct.variants.find(
          variant => variant.variantId === lineItem.variantId
        );

        if (!lineItemVariant) {
          return defaultCartLineItem;
        }

        return {
          prefix: lineItemProduct.prefix,
          title: lineItemProduct.title,
          price: lineItemVariant.price,
          variantOptions: lineItemVariant.variantOptions,
          productOptions: lineItemProduct.variantOptions,
          quantity: lineItem.quantity,
          image: lineItemProduct.images[lineItemVariant.imageIndex][0],
          productHandle: lineItem.productHandle,
          variantId: lineItemVariant.variantId
        };
      }
    );
  }
);
